import React from 'react';

import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';
import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Mobile/components/AllParamsButton';

import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import GearboxFilter from './components/GearboxFilter';
import PriceFilter from './components/PriceFilter';
import YearFilter from './components/YearFilter';
import BodyFilter from './components/BodyFilter';
import WheelFilter from './components/WheelFilter';
import MileageFilter from './components/MileageFilter';
import ColorFilter from './components/ColorFilter';
import EngineTypeFilter from './components/EngineTypeFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import SpecialFilter from './components/SpecialFilter';

export function ParamsFilterAll() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <EngineTypeFilter />
        <BodyFilter />
        <GearboxFilter />
        <PriceFilter />
      </FiltersWrapper>

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <WheelFilter />
          <YearFilter />
          <MileageFilter />
          <ColorFilter />
          <EngineCapacityFilter />
          <BatteryTypeFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
        </FiltersWrapper>
      </MoreParams>

      <AllParamsButton />

      <SpecialFilter />
    </React.Fragment>
  );
}
